import { render, staticRenderFns } from "./DataImportManager.vue?vue&type=template&id=4a6714e8&scoped=true"
import script from "./DataImportManager.vue?vue&type=script&lang=js"
export * from "./DataImportManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6714e8",
  null
  
)

export default component.exports